import React from "react";
import { DefaultOverview, DefaultTopics } from "./DefaultViews";
export const CommonConfigurationLetsEncryptOverview = () => {
    return <DefaultOverview />;
};
export const CommonConfigurationLetsEncryptTopics = () => {
    return <DefaultTopics />;
};
